export default "<h2><%= title %></h2>\n<p><%= message %></p>\n"